/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createAction } from 'redux-actions';

export const MODULE_LOADED = 'settings-view/MODULE_LOADED';
export const SAVE_VALIDATION_PLUGIN_CONFIG = 'settings-view/SAVE_VALIDATION_PLUGIN_CONFIG';
export const UPDATE_VALIDATION_CONFIG = 'settings-view/UPDATE_VALIDATION_CONFIG';
export const UPDATE_VIEW_PLUGIN_CONFIG = 'settings-view/UPDATE_VIEW_PLUGIN_CONFIG';
export const TOGGLE_USER_USES_ORG = 'settings-view/TOGGLE_USER_USES_ORG';

export const moduleLoaded = createAction(MODULE_LOADED);
export const saveValidationPluginConfig = createAction(SAVE_VALIDATION_PLUGIN_CONFIG);
export const updateValidationConfig = createAction(UPDATE_VALIDATION_CONFIG);
export const updateViewPluginConfig = createAction(UPDATE_VIEW_PLUGIN_CONFIG);
export const toggleUserUsesOrg = createAction(TOGGLE_USER_USES_ORG);
